import type { SubtitleTrack } from '../types/video'

type CaptionsState = {
  subtitleTracks: SubtitleTrack[]
  subtitleEnabled: boolean
  selectedSubtitleTrackId: number | null
  activeCaptionCue: string | null
  fontColor: string
  backgroundColor: string
  fontSize: string
}

const defaults: CaptionsState = {
  subtitleTracks: [],
  subtitleEnabled: false,
  selectedSubtitleTrackId: null,
  activeCaptionCue: null,
  fontColor: '#FFFFFF',
  backgroundColor: '#282828CC',
  fontSize: '1em',
}

const state: CaptionsState = $state(defaults)

const setCaptionsEnabled = (subtitleEnabled: boolean) => {
  if (!state.subtitleTracks.length) {
    state.subtitleEnabled = false
    return
  }
  if (
    subtitleEnabled &&
    !state.selectedSubtitleTrackId &&
    state.subtitleTracks.length
  ) {
    state.subtitleEnabled = subtitleEnabled
    state.selectedSubtitleTrackId = state.subtitleTracks[0].id
  }

  if (!subtitleEnabled) {
    state.subtitleEnabled = false
  }
}

const reset = () => {
  Object.assign(state, defaults)
}

export default { reset, setCaptionsEnabled, state }

// type StoreState = {
//   subtitleTracks: SubtitleTrack[] | null
//   subtitleEnabled: boolean
//   selectedSubtitleTrackId: number | null
//   activeCaptionCue: string | null
//   fontColor: string
//   backgroundColor: string
//   fontSize: string
// }
// const defaultStoreState: StoreState = {
//   subtitleTracks: null,
//   subtitleEnabled: false,
//   selectedSubtitleTrackId: null,
//   activeCaptionCue: null,
//   fontColor: '#FFFFFF',
//   backgroundColor: '#282828CC',
//   fontSize: '1em',
// }

// function chaptersStore() {
//   const { subscribe, set, update } = writable(defaultStoreState)

//   const reset = () =>
//     update((store) => ({
//       ...store,
//       subtitleTracks: null,
//       subtitleEnabled: false,
//       selectedSubtitleTrackId: null,
//       activeCaptionCue: null,
//     }))

//   const setSubtitleTracks = (subtitleTracks: SubtitleTrack[] | null) =>
//     update((store) => ({ ...store, subtitleTracks }))

//   const setSubtitleEnabled = (subtitleEnabled: boolean) => {
//     update((store) => {
//       if (!store.subtitleTracks?.length) {
//         return { ...store, subtitleEnabled: false }
//       }
//       if (
//         subtitleEnabled &&
//         store.selectedSubtitleTrackId === null &&
//         store.subtitleTracks?.length
//       ) {
//         return {
//           ...store,
//           subtitleEnabled,
//           selectedSubtitleTrackId: store.subtitleTracks[0].id,
//         }
//       }
//       return { ...store, subtitleEnabled }
//     })
//   }

//   const setSelectedSubtitleTrackId = (selectedSubtitleTrackId: number | null) =>
//     update((store) => ({ ...store, selectedSubtitleTrackId }))

//   const setActiveCaptionCue = (activeCaptionCue: string | null) =>
//     update((store) => ({ ...store, activeCaptionCue }))

//   return {
//     subscribe,
//     set,
//     update,
//     reset,
//     setSubtitleTracks,
//     setSubtitleEnabled,
//     setSelectedSubtitleTrackId,
//     setActiveCaptionCue,
//   }
// }

// export default chaptersStore()
